import { configureStore } from "@reduxjs/toolkit";
import { authenticationApi } from "@/api/authentication";
import { usersAdminApi } from "@/api/users-admin";
import { filesApi } from "@/api/files";
import { businessReportsApi } from "@/modules/snapshots/businessReports.api";
import { chronologyApi } from "@/api/chronology";
import { sharepointApi } from "@/api/sharepoint";
import { openChatApi } from "@/api/open-chat";
import { promptLibraryApi } from "@/modules/promptLibrary/promptLibrary.api";
import { transactionsApi } from "@/api/transactions";
import { myCalendarApi } from "@/modules/myCalendar/myCalendar.api";
import { snapshotCollectionApi } from "@/modules/snapshots/snapshotCollection.api";
import { setupListeners } from "@reduxjs/toolkit/query";

export const store = configureStore({
  reducer: {
    [authenticationApi.reducerPath]: authenticationApi.reducer,
    [usersAdminApi.reducerPath]: usersAdminApi.reducer,
    [filesApi.reducerPath]: filesApi.reducer,
    [businessReportsApi.reducerPath]: businessReportsApi.reducer,
    [chronologyApi.reducerPath]: chronologyApi.reducer,
    [sharepointApi.reducerPath]: sharepointApi.reducer,
    [openChatApi.reducerPath]: openChatApi.reducer,
    [promptLibraryApi.reducerPath]: promptLibraryApi.reducer,
    [transactionsApi.reducerPath]: transactionsApi.reducer,
    [myCalendarApi.reducerPath]: myCalendarApi.reducer,
    [snapshotCollectionApi.reducerPath]: snapshotCollectionApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      chronologyApi.middleware,
      transactionsApi.middleware,
      sharepointApi.middleware,
      authenticationApi.middleware,
      usersAdminApi.middleware,
      filesApi.middleware,
      openChatApi.middleware,
      businessReportsApi.middleware,
      myCalendarApi.middleware,
      snapshotCollectionApi.middleware,
      promptLibraryApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
